import React from 'react';
import '../App.css';

const AddTrackModal = ({ 
  isOpen, 
  onClose, 
  onSelectFavorites, 
  onSelectSaved, 
  onDiscoverNew,
  onSelectSpotify,
  onSelectLocal
}) => {
  if (!isOpen) return null;

  return (
    <div className="jam-modal-overlay" onClick={onClose}>
      <div className="jam-modal-content add-track-modal" onClick={(e) => e.stopPropagation()} style={{ overflow: 'visible' }}>
        <div className="jam-modal-header">
          <h2>➕ Add Track to Queue</h2>
          <button className="jam-modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="jam-modal-body" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', overflow: 'visible', paddingBottom: '3rem' }}>
          <h3 className="add-track-description" style={{ margin: '0 0 2rem 0', fontSize: '1.3rem', fontWeight: 600, color: 'rgba(255, 255, 255, 0.9)', textAlign: 'center' }}>Choose Your Track</h3>
          <div className="add-track-options" style={{ display: 'flex', flexDirection: 'row', gap: '4rem', alignItems: 'center', justifyContent: 'center', padding: 0, margin: 0 }}>
            {/* Discover */}
            <button 
              className="add-track-option-btn"
              onClick={onDiscoverNew}
              data-label="Discover"
              title="Discover new tracks"
              style={{ position: 'relative' }}
            >
              <span className="option-icon" style={{ fontSize: '2rem' }}>🔍</span>
              <span className="option-label-mobile">Discover</span>
            </button>

            {/* Spotify Library */}
            {onSelectSpotify && (
              <button 
                className="add-track-option-btn"
                onClick={onSelectSpotify}
                data-label="Spotify Library"
                title="Browse Spotify library"
                style={{ position: 'relative' }}
              >
                <span className="option-icon">
                  <img 
                    src="/logos/spotify-logo.png" 
                    alt="Spotify" 
                    style={{ width: '32px', height: '32px', filter: 'drop-shadow(0 3px 6px rgba(0, 0, 0, 0.4))' }}
                  />
                </span>
                <span className="option-label-mobile">Spotify</span>
              </button>
            )}

            {/* From Saved */}
            <button 
              className="add-track-option-btn"
              onClick={onSelectSaved}
              data-label="From Saved"
              title="Pick from saved tracks"
              style={{ position: 'relative' }}
            >
              <span className="option-icon" style={{ fontSize: '2rem' }}>💾</span>
              <span className="option-label-mobile">Saved</span>
            </button>

            {/* From Favorites */}
            <button 
              className="add-track-option-btn"
              onClick={onSelectFavorites}
              data-label="From Favorites"
              title="Pick from favorites"
              style={{ position: 'relative' }}
            >
              <span className="option-icon" style={{ fontSize: '2rem' }}>❤️</span>
              <span className="option-label-mobile">Favorites</span>
            </button>

            {/* Local Tracks */}
            {onSelectLocal && (
              <button 
                className="add-track-option-btn"
                onClick={onSelectLocal}
                data-label="Upload Tracks"
                title="Upload your own track (temporary)"
                style={{ position: 'relative' }}
              >
                <span className="option-icon" style={{ fontSize: '2rem' }}>📁</span>
                <span className="option-label-mobile">Upload</span>
              </button>
            )}
          </div>
        </div>

        <div className="jam-modal-footer">
          <button 
            className="jam-btn jam-btn-secondary" 
            onClick={onClose}
            style={{ padding: '0.4rem 0.8rem', fontSize: '0.85rem' }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddTrackModal;
